export default __webpack_public_path__ + "static/media/cat3c.da436e84.jpg";